import { charactersToWords } from './validations'
import { denominatorDataId, numeratorDataId } from './utils'
import { calculateWordCount } from '../../lib/utils/strings'

interface WordCountProps {
  value: string
  maxChars: number
}

export const WordCount = (props: WordCountProps) => {
  const { value, maxChars } = props

  const numWords = calculateWordCount(value)
  const maxWords = Math.floor(maxChars / charactersToWords)

  const ariaText = `${numWords} out of ${maxWords} words`

  return (
    <span aria-live="polite" role="status" aria-atomic="true" title={ariaText}>
      <span aria-hidden="true">
        <span data-classname={numeratorDataId}>{numWords}</span>/
        <span data-classname={denominatorDataId}>{`${maxWords} words`}</span>
      </span>
    </span>
  )
}
